import __regexp from './__chrome-ios-regexp';
/** Detect Google Chrome Browser on iOS */
export default function isChromeIOS(ua) {
	return __regexp.test(ua);
}
